import { runningCalculatorFromJson } from '../../RunningCalculator/utils/runningCalculatorFromJson.mjs'

/**
 * A class to convert UserData to and from Firestore.
 */
export class RunningCalculatorMapConverter {
  static toFirestore(runningCalculatorMap) {
    if (!runningCalculatorMap) {
      return null
    }
    return {
      calcs: Object.keys(runningCalculatorMap).reduce((acc, key) => {
        const calculator = runningCalculatorMap[key]
        acc[key] = calculator.toJson()
        return acc
      }, {}),
      date: +new Date(),
    }
  }
  static fromFirestore(snapshot, options) {
    let obj = snapshot.data(options)
    if (!obj) {
      return null
    }
    return Object.keys(obj.calcs).reduce((acc, key) => {
      const calculatorData = obj.calcs[key]
      if (calculatorData) {
        acc[key] = runningCalculatorFromJson(calculatorData)
      }
      return acc
    }, {})
  }
}
